// DennikMobile.jsx — V2 mobilný Denník  (ústava sek. 25 · 4.A · 39.A · 41 · 60 MOZOG)
// ════════════════════════════════════════════════════════════════════
// DENNIK_TUK_V1 (21. 10. 2026) — Denník na ťuk, ZADANIE MIRKA (Kronika ksbx-appky 2845, 2846, 2849, 2850):
// „vymysli logicky systém presetov pre ľudí, ktorí nevedia písať a nemajú radi techniku“, „popisy v jazyku používateľa“.
// Vzor: ~/Desktop/KAMIR Claude/MOCKUP_Dennik_predvolby_2026-10-21.html (verzia 2, OK Mirka 2864) — kroky dlaždicami:
//   Čo si dnes robil (Pre všetkých + sada človeka; omietkár a maliar majú svoju sadu navrchu a Pre všetkých zbalené;
//   iné remeslo pod tlačidlom) · Na čom (strop, steny, špalety) · S čím (materiál, predvolený posledný) · Kde (zo štruktúry
//   zákazky) · Stál si? (prestoj, hodiny ½/1/2/4/celý deň, kto zavinil) · Fotka (povinná pri neporiadku, nepripravenom
//   stavenisku, inej firme a pri prvom zápise na stavbe — ústava 41) → zhrnutie, poznámka, ULOŽIŤ ZÁPIS, „Chýba: …“.
// Dlaždice, texty a „kto som dnes“ idú zo servera (GET /api/diary/katalog) — ten istý zdroj ako iOS a Android.
// Zápis + fotky = jedna požiadavka POST /api/diary/zapis; server zloží slovenský text do knihy a stráži fotky.
// Majster/admin: Prvý / Kontrolný / Posledný tými istými dlaždicami (zistenia z katalógu kontrol, ústava 25.2).
// Typ zákazky dlaždice nemení (mockup v2 „rozhoduje človek a jeho deň“) — protokol liatia (4.A.X) je tlačidlo pod formulárom,
// pri poterovej zákazke výrazné; Pokládka/Anhydrit ostávajú v MobileApp. Zámok dňa (39.A), lock + dirty (53.7 / 53.1).

import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { COLORS, TYPO, SPACE, RADIUS, TINT } from '../theme.js'
import NavIcon from '../components/NavIcon.jsx'
import { useT, getLang } from '../i18n.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { useToast } from '../components/Toast.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { kvGet, kvSet, obAll, obPut, obDel, newUid, compressPhoto, flushDiary } from '../offline/diaryOffline.js'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import { bytNazov } from '../lib/byt.js'
import Modal from '../components/Modal.jsx'
import PoterProtokolView from './PoterProtokolView.jsx'

const AMBER = COLORS.warn
const AMBER_BG = '#FEF3C7'
const KONTROLA_TYPY = ['prvy', 'kontrolny', 'posledny']

// legacy entry_type → kanonický (staré dáta z old Matrix: first/daily/inspection/…)
const TYPE_MAP = {
  first: 'prvy', start: 'prvy', daily: 'denny',
  inspection: 'kontrolny', supervisor: 'kontrolny',
  last: 'posledny', end: 'posledny', handover: 'posledny',
  partial: 'priebezny', interim: 'priebezny',
}
function normType(et) {
  if (['prvy', 'denny', 'kontrolny', 'posledny', 'priebezny'].includes(et)) return et
  return TYPE_MAP[et] || 'denny'
}
// text zápisu v jazyku diváka (ústava 6): originál ak je v jeho jazyku, inak SK preklad
function zobrazText(e, lang) {
  const ol = String(e?.original_lang || '').toLowerCase()
  return (ol && ol === lang && e?.original_text) ? e.original_text : (e?.work_description || '')
}
const jsonPole = (s) => { try { const a = JSON.parse(s || '[]'); return Array.isArray(a) ? a : [] } catch (_) { return [] } }
const vypln = (s, v) => { let t = String(s || ''); for (const k in (v || {})) t = t.split('{' + k + '}').join(String(v[k])); return t }
const hodText = (kat, h) => ((kat?.hodiny || []).find(x => Number(x.h) === Number(h)) || {}).text || (h + ' h')
// všetky položky katalógu podľa kľúča (dlaždice prác, kontrol aj prestoje) — na popis zápisu v jazyku človeka
function mapaKatalogu(kat) {
  const m = {}
  if (!kat) return m
  for (const s of [...(kat.sady || []), ...(kat.ine_remesla || []), ...(kat.kontrola || [])]) for (const p of (s.polozky || [])) m[p.kluc] = p
  for (const p of (kat.prestoje || [])) m[p.kluc] = p
  return m
}
function miestaZoZapisu(e) {
  return jsonPole(e?.locations).filter(b => b && (b.object || b.floor) && b.floor !== 'Celok diela')
    .map(b => ({ obj: String(b.object || ''), po: String(b.floor || ''), byt: String(b.flat || '') }))
}
const miestoText = (m) => [m.obj, m.po, m.byt].filter(Boolean).join(' ')
const pocetFotiekText = (T, n) => vypln(n === 1 ? T.zhr_foto_1 : (n >= 2 && n <= 4) ? T.zhr_foto_2 : T.zhr_foto_5, { n })
const vsetkySady = (kat) => [...(kat?.sady || []), ...(kat?.ine_remesla || [])]
// riadok zoznamu: zápis na ťuk sa ukáže z kľúčov v jazyku človeka, starý zápis ako doteraz
function popisZapisu(e, kat, lang) {
  const kluce = jsonPole(e?.prace_kluce)
  const mk = mapaKatalogu(kat)
  // zápis upravený v Matrixe (office) ukáže text knihy — úprava môže byť iná než dlaždice
  const upravenyInde = e?.updated_by && e?.created_by && String(e.updated_by) !== String(e.created_by)
  if (!kluce.length || upravenyInde || !kluce.every(k => mk[k])) return zobrazText(e, lang)
  const mi = miestaZoZapisu(e).map(miestoText).join(', ') || (kat?.miesta?.celok_text || '')
  return kluce.map(k => mk[k].text).join(', ') + (mi ? ' — ' + mi : '')
}
// „streda 21. 10.“ — dni zo slovníka servera (texty.dni), telefón nemusí mať jazyk človeka
const denVTyzdni = (T, iso) => {
  try { const d = new Date(String(iso).slice(0, 10) + 'T12:00:00'); const dni = String(T.dni || '').split(',')
    return (dni[d.getDay()] ? dni[d.getDay()] + ' ' : '') + d.getDate() + '. ' + (d.getMonth() + 1) + '.' }
  catch (_) { return iso }
}

const M = {
  page:  { padding: SPACE.md, display: 'flex', flexDirection: 'column', gap: SPACE.sm, background: COLORS.page, minHeight: '100%' },
  h1:    { margin: 0, fontSize: TYPO.sizes.xl, fontWeight: TYPO.weights.extra, color: COLORS.text },
  card:  { background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: 16, padding: 12 },
  nad:   { fontSize: 11.5, fontWeight: 800, color: COLORS.muted, letterSpacing: '.04em', textTransform: 'uppercase', margin: '0 0 8px', display: 'flex', alignItems: 'center' },
  krok:  { display: 'inline-block', background: COLORS.nav, color: '#fff', borderRadius: 999, width: 20, height: 20, textAlign: 'center', lineHeight: '20px', fontSize: 12, marginRight: 6, flexShrink: 0 },
  sk:    { fontSize: 11.5, fontWeight: 800, color: COLORS.nav, margin: '10px 0 6px', textTransform: 'uppercase' },
  grid:  { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 },
  chips: { display: 'flex', flexWrap: 'wrap', gap: 6 },
  pozn:  { color: COLORS.muted, fontSize: 12, margin: '8px 0 0', lineHeight: 1.4 },
  input: { width: '100%', minHeight: 46, fontSize: TYPO.sizes.md, padding: '10px 12px', border: `1px solid ${COLORS.line}`, borderRadius: 12,
           fontFamily: 'inherit', boxSizing: 'border-box', outline: 'none', background: COLORS.bgSoft },
  btnPrimary: { width: '100%', minHeight: 52, background: COLORS.nav, color: '#fff', border: 'none', borderRadius: 16,
                fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.bold, fontFamily: 'inherit', cursor: 'pointer' },
  btnGhost: { minHeight: 44, background: 'transparent', color: COLORS.nav, border: `1px solid ${COLORS.line}`, borderRadius: 12,
              fontSize: TYPO.sizes.base, fontFamily: 'inherit', cursor: 'pointer', padding: '0 16px', fontWeight: 600 },
}
function dl(on, amber, dashed) {
  const c = amber ? AMBER : COLORS.nav
  return { background: on ? c : COLORS.bgSoft, border: `2px ${dashed ? 'dashed' : 'solid'} ${on ? c : COLORS.line}`, color: on ? '#fff' : COLORS.text,
    borderRadius: 14, padding: '10px 8px', minHeight: 66, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
    textAlign: 'center', fontWeight: 700, fontSize: 14, gap: 4, cursor: 'pointer', fontFamily: 'inherit', lineHeight: 1.2, width: '100%' }
}
function chip(on, amber) {
  const c = amber ? AMBER : COLORS.nav
  return { minHeight: 40, padding: '8px 13px', borderRadius: 999, background: on ? c : COLORS.bgSoft, border: `1.5px solid ${on ? c : COLORS.line}`,
    color: on ? '#fff' : COLORS.text, fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }
}
function Dlazdica({ on, amber, dashed, ikona, text, mini, onClick }) {
  return (
    <button type="button" onClick={onClick} style={dl(on, amber, dashed)} aria-pressed={!!on}>
      {ikona ? <span style={{ display: 'flex', color: on ? '#fff' : (amber ? AMBER : COLORS.nav) }}><NavIcon name={ikona} size={24} /></span> : null}
      <span>{text}</span>
      {mini ? <span style={{ fontSize: 10.5, fontWeight: 600, opacity: 0.85 }}>{mini}</span> : null}
    </button>
  )
}
function Karta({ krok, nadpis, children, style }) {
  return (
    <div style={{ ...M.card, ...(style || {}) }}>
      {nadpis ? <p style={M.nad}>{krok ? <span style={M.krok}>{krok}</span> : null}<span>{nadpis}</span></p> : null}
      {children}
    </div>
  )
}

// OFFLINE (2026-07-12): neodoslané zápisy z outboxu ako položky zoznamu
async function pendingAsEntries() {
  const items = (await obAll()).filter(it => !it.photos_only)
  return items.map(it => {
    const b = it.tuk ? (it.data || {}) : (it.body || {})
    return { id: 'LOC' + it.client_uid, date: b.date || it.datum || '', entry_type: b.entry_type || 'denny', project_id: b.project_id,
      project_name: it.project_name || '', work_description: it.tuk ? (it.popis || '') : b.work_description,
      photo_count: it.tuk ? (it.fotky || []).length : (it.blobs || []).length, _local: true, _err: it.err || '', _cuid: it.client_uid }
  })
}

// ══════════════════════════════════════════════════════════════════
export default function DennikMobile() {
  const t = useT()
  const toast = useToast()
  const { user } = useAuth()
  const lang = getLang(user)
  const [entries, setEntries] = useState([])
  const [vyzvy, setVyzvy] = useState([])
  const [kat, setKat] = useState(null)
  const [loading, setLoading] = useState(true)
  const [edit, setEdit] = useState(null)
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine)
  const control = kat ? kat.rezim === 'kontrolny' : ['foreman', 'owner', 'owner_view', 'admin'].includes(user?.role)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const k = await fetchAuth('/api/diary/katalog').then(r => r.ok ? r.json() : null).catch(() => null)
      if (k) { setKat(k); kvSet('dnk_kat', k) } else { const c = await kvGet('dnk_kat'); if (c) setKat(c) }
      const r = await fetchAuth('/api/diary/all?limit=60')
      const d = await r.json()
      const arr = Array.isArray(d) ? d : []
      kvSet('dnk_entries', arr)
      setEntries((await pendingAsEntries()).concat(arr))
      // výzvy „koniec etapy" — len Majster/control (ústava 4.A — uzavretie slučky)
      if (['foreman', 'owner', 'owner_view', 'admin'].includes(user?.role)) {
        const vr = await fetchAuth('/api/diary/koniec-etapy/pending').then(x => x.json()).catch(() => [])
        setVyzvy(Array.isArray(vr) ? vr : [])
      }
    } catch (_) { // offline → cache + neodoslané z outboxu
      const cached = await kvGet('dnk_entries'); const base = Array.isArray(cached) ? cached : []
      const ck = await kvGet('dnk_kat'); if (ck) setKat(ck)
      setEntries((await pendingAsEntries()).concat(base))
      if (!base.length) toast.error(t('common.error'))
    }
    finally { setLoading(false) }
  }, [toast, t, user])
  useEffect(() => { load() }, [load])

  // OFFLINE badge + auto-flush (online event + 45 s)
  const [pendCount, setPendCount] = useState(0)
  useEffect(() => {
    const refresh = async () => setPendCount((await obAll()).length)
    const tryFlush = async () => { const r = await flushDiary(); if (r.sent) { toast.success((kat?.texty?.ulozene || 'Odoslané') + ': ' + r.sent); load() } refresh() }
    const zap = () => { setOnline(true); tryFlush() }, vyp = () => setOnline(false)
    refresh(); if (navigator.onLine) tryFlush()
    const iv = setInterval(tryFlush, 45000)
    window.addEventListener('online', zap); window.addEventListener('offline', vyp)
    return () => { clearInterval(iv); window.removeEventListener('online', zap); window.removeEventListener('offline', vyp) }
  }, [load, toast, kat])

  if (edit) {
    return <ZapisNaTuk record={edit.record} prefill={edit.prefill} katZoznamu={kat}
      onClose={() => { setEdit(null); load() }}
      onSaved={() => { setEdit(null); load() }} />
  }
  const T = kat?.texty || {}
  const dnesne = (kat?.dnes?.zapisy || [])
  return (
    <div style={M.page}>
      <h1 style={M.h1}>{t('mobile.tab.dennik')}</h1>
      <button style={M.btnPrimary} onClick={() => setEdit({ record: null })}>{T.novy || ('+ ' + t('dennik.new'))}</button>
      {dnesne.length > 0 && !control && (
        <button onClick={() => { const e = entries.find(x => x.id === dnesne[0].id); if (e) setEdit({ record: e }) }}
          style={{ ...M.card, textAlign: 'left', cursor: 'pointer', border: `2px solid ${COLORS.add}`, background: COLORS.addBg, color: COLORS.add, fontWeight: 700, display: 'flex', gap: 8, alignItems: 'center', fontFamily: 'inherit', fontSize: TYPO.sizes.sm }}>
          <NavIcon name="ok" size={20} /> <span>{T.dnes_hotovy}</span>
        </button>
      )}
      {!online && (
        <div style={{ ...M.card, border: `2px solid ${COLORS.remove}`, background: '#FEE2E2', color: COLORS.remove, fontWeight: 700 }}>
          {T.offline || 'Bez pripojenia — zápisy sa ukladajú do telefónu a odošlú sa samy.'}
        </div>
      )}
      {pendCount > 0 && (
        <button onClick={async () => { const r = await flushDiary({ ajChybne: true }); if (r.sent) load(); setPendCount((await obAll()).length) }}
          style={{ ...M.card, width: '100%', textAlign: 'left', cursor: 'pointer', border: `2px solid ${AMBER}`, background: AMBER_BG, color: '#92400e', fontWeight: 700, fontFamily: 'inherit' }}>
          {(T.offline_ok || 'Neodoslané zápisy') + ' (' + pendCount + ')'}
        </button>
      )}

      {/* VÝZVY — parťák ohlásil koniec etapy → Majster over (ústava 4.A). Ťuk otvorí nový Kontrolný zápis pre tú zákazku. */}
      {vyzvy.map(v => (
        <button key={'v' + v.id} onClick={() => setEdit({ record: null, prefill: { project_id: v.project_id, entry_type: 'kontrolny' } })} style={{
          ...M.card, width: '100%', textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: SPACE.md, minHeight: 64,
          border: `2px solid ${COLORS.total}`, background: COLORS.totalBg, fontFamily: 'inherit' }}>
          <span style={{ flexShrink: 0, display: 'flex', color: COLORS.total }}><NavIcon name="zvonec" size={24} /></span>
          <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
            <span style={{ fontWeight: TYPO.weights.bold, color: COLORS.total, fontSize: TYPO.sizes.md }}>{v.project_name || v.project_id} — {t('dennik.vyzva_label')}</span>
            <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.total }}>→ {t('dennik.vyzva_action')}</span>
          </span>
        </button>
      ))}

      {loading ? (
        <div style={{ ...M.card, textAlign: 'center', color: COLORS.muted }}>{t('common.loading')}</div>
      ) : entries.length === 0 ? (
        <div style={{ ...M.card, textAlign: 'center', color: COLORS.muted }}>{t('dennik.empty')}</div>
      ) : entries.map(e => (
        <button key={e.id} onClick={async () => {
            if (!e._local) { setEdit({ record: e }); return }
            if (!e._err) { toast.info(T.offline_ok || 'Zápis čaká na odoslanie.'); return }
            // zápis, ktorý server odmietol (napr. iný deň, bez Príchodu) — človek ho môže zahodiť z telefónu
            if (window.confirm(vypln(T.zahodit_otazka || 'Zápis sa nedá odoslať: {chyba}. Zahodiť?', { chyba: e._err }))) { await obDel(e._cuid); load() }
          }} style={{ ...M.card, textAlign: 'left', width: '100%', cursor: 'pointer', display: 'flex', flexDirection: 'column', gap: 4, minHeight: 60, fontFamily: 'inherit' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
            <span style={{ fontWeight: TYPO.weights.bold, fontSize: TYPO.sizes.md }}>{e.date}</span>
            <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.nav, background: TINT.nav, borderRadius: RADIUS.sm, padding: '2px 8px' }}>
              {t('dennik.type.' + normType(e.entry_type))}
            </span>
            {e.rozsah === 'byt' && e.byt_cislo && (
              <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.total, background: COLORS.totalBg, borderRadius: RADIUS.sm, padding: '2px 8px' }}>
                {bytNazov(e.byt_cislo, t('dennik.flat'))}
              </span>
            )}
            {Number(e.stoppage_hours) > 0 && (
              <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: '#92400e', background: AMBER_BG, borderRadius: RADIUS.sm, padding: '2px 8px' }}>
                {T.prestoj || 'Prestoj'} {hodText(kat, e.stoppage_hours)}
              </span>
            )}
            {e.created_via === 'anton' && (
              <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.muted, border: `1px solid ${COLORS.lineSoft}`, borderRadius: RADIUS.sm, padding: '2px 8px' }}>Anton</span>
            )}
            <span style={{ flex: 1 }} />
            {e._local && <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: e._err ? COLORS.remove : '#92400e', background: e._err ? '#FEE2E2' : AMBER_BG, borderRadius: RADIUS.sm, padding: '2px 8px' }}>{e._err ? '!' : '…'}</span>}
            {e.is_locked && <span title="Zákon 50/1976" style={{ display: 'inline-flex', color: COLORS.muted }}><NavIcon name="lock" size={14} /></span>}
            {e.photo_count > 0 && <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, display: 'inline-flex', alignItems: 'center', gap: 3 }}><NavIcon name="fotky" size={14} />{e.photo_count}</span>}
          </div>
          <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm, whiteSpace: 'normal', wordBreak: 'break-word' }}>
            {e.project_name || e.project_id} · {popisZapisu(e, kat, lang) || '—'}
          </div>
        </button>
      ))}
    </div>
  )
}

// ══════════════════════════════════════════════════════════════════
// ZapisNaTuk — editor zápisu podľa mockupu (nový zápis aj doplnenie svojho dnešného)
// ══════════════════════════════════════════════════════════════════
const LIMIT_FOTIEK = { foto_prestoj: 5, foto_predstav: 5, foto: 10 }   // rovnako ako server (diary_v2_api prijemFotiek)
const casTeraz = () => { const d = new Date(); return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0') }
// tučná časť vety v zhrnutí („Prestoj **2 h — neporiadok na stavbe**, zavinil objednávateľ“) — šablóna má {h} pred {dovod}
function VetaPrestoja({ sablona, h, dovod, kto }) {
  const a = sablona.indexOf('{h}'), b = sablona.indexOf('{dovod}')
  if (a < 0 || b < a) return <>{vypln(sablona, { h, dovod, kto })}</>
  return <>{vypln(sablona.slice(0, a), { kto })}<b>{vypln(sablona.slice(a, b + 7), { h, dovod })}</b>{vypln(sablona.slice(b + 7), { kto })}</>
}
// „Dnes si v Rozpise prác ako **Poterár** — …“
function VetaKto({ veta, osoba }) {
  const i = osoba ? veta.indexOf(osoba) : -1
  if (i < 0) return <>{veta}</>
  return <>{veta.slice(0, i)}<b>{osoba}</b>{veta.slice(i + osoba.length)}</>
}

function ZapisNaTuk({ record, prefill, katZoznamu, onClose, onSaved }) {
  const { user } = useAuth()
  const toast = useToast()
  const lang = getLang(user)
  const novy = !record
  const ja = (user && (user.display_name || user.username)) || ''
  const admin = user?.role === 'admin'
  // starý tvar = zápis spred Denníka na ťuk (prace_kluce prázdne); cudzí zápis doplní len admin (Mirko 29. 9., matrix 1008)
  const staryTvar = !!record && !record.prace_kluce && !record.stoppage_kluc
  const cudzi = !!record && !admin && String(record.created_by || '') !== ja
  const upravenyInde = !!record && !admin && !!record.updated_by && record.updated_by !== record.created_by
  const lenCitanie = staryTvar || cudzi || upravenyInde
  const [pid, setPid] = useState(record?.project_id || prefill?.project_id || katZoznamu?.zakazka?.id || '')
  const [kat, setKat] = useState(katZoznamu && (!pid || katZoznamu?.zakazka?.id === pid) ? katZoznamu : null)
  const [katZnovu, setKatZnovu] = useState(0)
  const [projekty, setProjekty] = useState([])
  const [ineOpen, setIneOpen] = useState(false)
  const [vsetciOpen, setVsetciOpen] = useState(false)   // mockup v2: „Pre všetkých … — rozbaliť“
  const [protokolOpen, setProtokolOpen] = useState(false)
  const [teplota, setTeplota] = useState(record?.temp_avg ?? null)
  const [nove, setNove] = useState([])          // nové fotky: { pole, blob, url, kedy }
  const [stare, setStare] = useState([])        // uložené fotky zápisu (doplnenie)
  const [hotovo, setHotovo] = useState(null)    // { offline }
  const fotoRef = useRef(null)
  const poleFotky = useRef('foto')
  const noveRef = useRef(nove); noveRef.current = nove
  const vznik = useRef({ date: record?.date || '', time: record?.entry_time || casTeraz() })   // dátum a čas vzniku (offline odošle neskôr)
  const T = kat?.texty || {}
  const control = (kat?.rezim || '') === 'kontrolny' || ['foreman', 'owner', 'owner_view', 'admin'].includes(user?.role)

  // katalóg pre zákazku (texty, dlaždice, miesta, kto som) — offline len z pamäte tej istej zákazky
  useEffect(() => {
    let zive = true
    if (kat && pid && kat.zakazka && kat.zakazka.id !== pid) setKat(null)
    const q = '/api/diary/katalog' + (pid ? '?project_id=' + encodeURIComponent(pid) : '')
    fetchAuth(q).then(r => r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)))
      .then(k => { if (!zive) return; setKat(k); if (!pid && k.zakazka) setPid(k.zakazka.id); kvSet('dnk_kat_' + (k.zakazka?.id || pid || ''), k) })
      .catch(async () => { const c = await kvGet('dnk_kat_' + (pid || '')) || (pid ? null : await kvGet('dnk_kat')); if (zive && c) setKat(c) })
    return () => { zive = false }
  }, [pid, katZnovu])   // eslint-disable-line react-hooks/exhaustive-deps
  // výber zákazky: technik, majiteľ a admin hocijakú; parťák zo zákaziek dňa (Rozpis, Príchod)
  useEffect(() => {
    if (!control && !(kat && !kat.zakazka && !(kat.zakazky_dna || []).length)) return
    fetchAuth('/api/projects?scope=all').then(r => r.json())
      .then(d => { const arr = Array.isArray(d) ? d.filter(p => p.status !== 'done') : []; setProjekty(arr); kvSet('dnk_projects', arr) })
      .catch(async () => { const c = await kvGet('dnk_projects'); if (Array.isArray(c)) setProjekty(c) })
  }, [control, !!kat])   // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (record?.id) fetchAuth('/api/diary/' + record.id).then(r => r.json()).then(d => setStare(Array.isArray(d.photos) ? d.photos : [])).catch(() => {}) }, [record])
  // teplota zo zákazky (ústava 25.6) — sama, bez ťuku
  useEffect(() => {
    if (!pid || teplota != null) return
    fetchAuth('/api/weather?project_id=' + encodeURIComponent(pid)).then(r => r.ok ? r.json() : null).then(d => {
      if (!d) return; let x = d.current ?? d.temperature ?? d.temp ?? d.temp_avg
      if (x == null && d.temp_min != null && d.temp_max != null) x = (d.temp_min + d.temp_max) / 2
      if (x != null) setTeplota(Math.round(Number(x)))
    }).catch(() => {})
  }, [pid, teplota])
  // náhľady fotiek sa uvoľnia pri zatvorení editora
  useEffect(() => () => { (noveRef.current || []).forEach(x => { try { URL.revokeObjectURL(x.url) } catch (_) {} }) }, [])

  // počiatočné hodnoty (doplnenie = rozložený uložený zápis); denný typ je predvolený pre každého (Mirko 29. 9., matrix 1007)
  const initial = useMemo(() => {
    const kl = jsonPole(record?.prace_kluce)
    const typ = record ? normType(record.entry_type) : (prefill?.entry_type || 'denny')
    const opatr = String(record?.issues || '').match(/^OPATRENIE: (.*?)(?: · termín (.*?))?(?: · zodp\. (.*))?$/) || []
    const prevz = String(record?.notes || '')
    let pozn = ''
    if (record) {
      if (String(record.original_lang || '').toLowerCase() === lang && record.original_text) pozn = record.original_text
      else { const m = String(record.work_description || '').match(/\nPoznámka(?: \([A-Z]+ originál\))?: ([\s\S]*)$/); if (m) pozn = m[1] }
    }
    return {
      entry_type: typ,
      prace: KONTROLA_TYPY.includes(typ) ? [] : kl,
      kontrola: KONTROLA_TYPY.includes(typ) ? kl : [],
      miesta: record ? miestaZoZapisu(record) : [],
      na_com: jsonPole(record?.na_com),
      materialy: jsonPole(record?.materialy).reduce((a, m) => { if (m && m.sada && m.kluc) a[m.sada] = m.kluc; return a }, {}),
      prestoj: record?.stoppage_kluc || '',
      hodiny: Number(record?.stoppage_hours) || 0,
      zavinil: record?.stoppage_zavinil || '',
      poznamka: pozn,
      opatr_co: opatr[1] || '', opatr_do: opatr[2] || '', opatr_kto: opatr[3] || '',
      prevzatie: (prevz.match(/Prevzaté: (.*?)(?: · Odovzdané|$)/) || [])[1] || '',
      odovzdanie: (prevz.match(/Odovzdané: (.*)$/) || [])[1] || '',
      fotky_n: 0,
    }
  }, [])   // eslint-disable-line react-hooks/exhaustive-deps

  const typy = (kat && Array.isArray(kat.typy) && kat.typy.length) ? kat.typy : (control ? ['denny', ...KONTROLA_TYPY] : ['denny'])
  // mockup v2 — „Na čom“: keď je vybraná práca s na_com; „S čím“: sady s materiálom, v ktorých je vybraná práca
  const polozkaPrace = useCallback((k) => { for (const s of vsetkySady(kat)) { const p = (s.polozky || []).find(x => x.kluc === k); if (p) return { p, s } } return null }, [kat])
  const sadySCim = useCallback((prace) => vsetkySady(kat).map(s => {
    const vybrane = (s.polozky || []).filter(p => prace.includes(p.kluc)).map(p => p.kluc)
    if (!vybrane.length || !(s.materialy || []).length) return null
    const mats = s.materialy.filter(m => !(m.pre_prace || []).length || m.pre_prace.some(k => vybrane.includes(k)))
    if (!mats.length) return null
    const pre = [...new Set(mats.flatMap(m => m.pre_prace || []))].filter(k => vybrane.includes(k))
    return { sada: s.sada, mats, pre, posledny: s.material_posledny || '' }
  }).filter(Boolean), [kat])
  const materialyNaOdoslanie = useCallback((v) => {
    const o = {}; for (const x of sadySCim(v.prace)) { const k = (v.materialy || {})[x.sada]; if (k && x.mats.some(m => m.kluc === k)) o[x.sada] = k } return o
  }, [sadySCim])
  const savedUid = useRef(null)   // client_uid zápisu — opakované odoslanie (offline, dvojitý ťuk) nevyrobí druhý
  const suhrnRef = useRef('')
  const vysledok = useRef(null)
  const odoslat = useCallback(async (v) => {
    const typ = typy.includes(v.entry_type) ? v.entry_type : 'denny'
    const kontr = KONTROLA_TYPY.includes(typ)
    const p = (kat?.prestoje || []).find(x => x.kluc === v.prestoj)
    const naComTreba0 = (v.prace || []).some(k => { const x = polozkaPrace(k); return x && x.p.na_com })
    const data = {
      client_uid: record?.client_uid || savedUid.current || newUid(), project_id: pid, entry_type: typ, lang,
      date: vznik.current.date || kat?.datum || '', entry_time: vznik.current.time,
      prace: kontr ? [] : v.prace, kontrola: kontr ? v.kontrola : [], miesta: v.miesta,
      na_com: (kontr || !naComTreba0) ? [] : v.na_com, materialy: kontr ? {} : materialyNaOdoslanie(v),
      prestoj: (!kontr && p) ? { kluc: p.kluc, hodiny: v.hodiny, zavinil: v.zavinil } : null,
      poznamka: v.poznamka,
      opatrenie: kontr ? { co: v.opatr_co, do: v.opatr_do, kto: v.opatr_kto } : null,
      prevzatie: kontr ? v.prevzatie : '', odovzdanie: kontr ? v.odovzdanie : '',
      worker_count: Math.max(1, Number(kat?.dnes?.ludia) || 1), temp_avg: teplota,
    }
    savedUid.current = data.client_uid
    // fotka ide do poľa podľa toho, čo zápis naozaj žiada (prestoj zrušený → obyčajná fotka)
    const trebaPrestoj = !kontr && !!(p && p.fotka_povinna), trebaPredstav = !!kat?.prvy_zapis && novy
    const fotky = nove.map(x => ({ ...x, pole: (x.pole === 'foto_prestoj' && !trebaPrestoj) || (x.pole === 'foto_predstav' && !trebaPredstav) ? 'foto' : x.pole }))
    const fd = new FormData()
    fd.append('data', JSON.stringify(data))
    fotky.forEach((x, i) => fd.append(x.pole, x.blob, x.pole + '_' + (i + 1) + '.jpg'))
    let r
    try {
      r = await fetchAuth(record?.id ? '/api/diary/zapis/' + record.id : '/api/diary/zapis', { method: record?.id ? 'PUT' : 'POST', body: fd })
    } catch (_) {
      // bez signálu: nový zápis aj s fotkami do telefónu, odošle sa sám (client_uid = bez duplicity, dátum vzniku ostáva)
      if (record?.id) throw new Error(T.offline || 'Bez signálu')
      const ok = await obPut({ client_uid: data.client_uid, tuk: true, data, datum: data.date, project_name: kat?.zakazka?.nazov || '',
        popis: suhrnRef.current, fotky: fotky.map(x => ({ pole: x.pole, blob: x.blob })) })
      if (!ok) throw new Error(T.telefon_plny || 'Zápis sa nepodarilo uložiť ani do telefónu.')
      return { offline: true }
    }
    const d = await r.json().catch(() => ({}))
    if (!r.ok) throw new Error(d.message || d.error || ('HTTP ' + r.status))
    return { offline: false, entry: d.entry }
  }, [kat, pid, lang, nove, record, teplota, T, typy, novy, polozkaPrace, materialyNaOdoslanie])

  const ed = useRecordEditor({
    resource: 'diary', id: (record && !lenCitanie) ? record.id : null, user, initial, fields: [],
    onSubmit: async (v) => { vysledok.current = await odoslat(v) },
  })
  const f = ed.values
  const set = ed.set
  const zamknute = !!record?.is_locked
  const kontrolny = KONTROLA_TYPY.includes(f.entry_type)

  const naComTreba = !kontrolny && !!(f.prace || []).some(k => { const x = polozkaPrace(k); return x && x.p.na_com })
  const maliarVybrany = (f.prace || []).some(k => { const x = polozkaPrace(k); return x && x.s.sada === 'malby' })
  const sCim = kontrolny ? [] : sadySCim(f.prace || [])
  // „Predvolený je materiál, s ktorým robil naposledy“ — doplní sa, keď sa v sade objaví prvá práca
  useEffect(() => {
    const doplnit = sCim.filter(x => x.posledny && !(f.materialy || {})[x.sada] && x.mats.some(m => m.kluc === x.posledny))
    if (doplnit.length) set('materialy', { ...(f.materialy || {}), ...Object.fromEntries(doplnit.map(x => [x.sada, x.posledny])) })
  }, [sCim.map(x => x.sada).join(',')])   // eslint-disable-line react-hooks/exhaustive-deps

  const mk = useMemo(() => mapaKatalogu(kat), [kat])
  const prestoj = (kat?.prestoje || []).find(x => x.kluc === f.prestoj) || null
  const miestaZak = kat?.miesta?.polozky || []
  const objekty = [...new Set(miestaZak.map(m => m.obj))]
  const vybraneMiesto = (m) => f.miesta.some(x => x.obj === m.obj && x.po === m.po)
  const prepniMiesto = (m) => {
    if (vybraneMiesto(m)) set('miesta', f.miesta.filter(x => !(x.obj === m.obj && x.po === m.po)))
    else set('miesta', [...f.miesta.map(x => ({ ...x, byt: '' })), { obj: m.obj, po: m.po, byt: '' }])
  }
  const jednoMiesto = f.miesta.length === 1 ? miestaZak.find(m => m.obj === f.miesta[0].obj && m.po === f.miesta[0].po) : null
  const prepni = (pole, k) => set(pole, f[pole].includes(k) ? f[pole].filter(x => x !== k) : [...f[pole], k])
  const vyberPrestoj = (p) => {
    if (!p) { set('prestoj', ''); set('hodiny', 0); set('zavinil', ''); return }
    set('prestoj', p.kluc); set('zavinil', p.kto_zavinil || f.zavinil || '')
  }

  // fotky
  const pocetFotiek = (pole, ucel) => nove.filter(x => x.pole === pole).length + stare.filter(x => (x.ucel || '') === ucel).length
  const potrebaPrestoj = !kontrolny && !!(prestoj && prestoj.fotka_povinna)
  const potrebaPredstav = !!kat?.prvy_zapis && novy
  const chybaPredstav = potrebaPredstav && pocetFotiek('foto_predstav', 'pred_stav') === 0
  const chybaPrestoj = potrebaPrestoj && pocetFotiek('foto_prestoj', 'prestoj') === 0
  const nadpisFotky = [potrebaPredstav ? T.foto_predstav : '', potrebaPrestoj ? (prestoj.fotka_text || T.foto_prestoj) : ''].filter(Boolean).join(' + ') || T.krok_foto || ''
  const otvorFoto = (pole) => { poleFotky.current = pole; if (fotoRef.current) { fotoRef.current.value = ''; fotoRef.current.click() } }
  const dalsiePole = () => chybaPredstav ? 'foto_predstav' : (chybaPrestoj ? 'foto_prestoj' : 'foto')
  async function pridajFotky(ev) {
    const files = Array.from(ev.target.files || []); if (!files.length) return
    const add = []
    const pocet = (pole) => nove.filter(x => x.pole === pole).length + add.filter(x => x.pole === pole).length
    for (const fl of files) {
      // prvá fotka ide tam, kam ťukol (povinná), ďalšie medzi ostatné; limity ako server
      let pole = add.length === 0 ? poleFotky.current : 'foto'
      if (pocet(pole) >= LIMIT_FOTIEK[pole]) pole = 'foto'
      if (pocet('foto') >= LIMIT_FOTIEK.foto && pole === 'foto') break
      const b = await compressPhoto(fl); add.push({ pole, blob: b, url: URL.createObjectURL(b), kedy: new Date() })
    }
    setNove(n => { const x = [...n, ...add]; set('fotky_n', x.length); return x })
  }
  const odober = (i) => setNove(n => { const x = n.filter((_, j) => j !== i); try { URL.revokeObjectURL(n[i].url) } catch (_) {} set('fotky_n', x.length); return x })
  const prefotit = (i) => { const pole = nove[i] ? nove[i].pole : 'foto'; odober(i); otvorFoto(pole) }
  async function odoberStaru(p) {
    if (!window.confirm(T.odobrat_otazka || 'Odobrať fotku?')) return
    try { const r = await fetchAuth('/api/diary/photos/' + p.id, { method: 'DELETE' }); if (!r.ok) throw new Error(); setStare(s => s.filter(x => x.id !== p.id)) }
    catch (_) { toast.error(T.nepodarilo || 'Nepodarilo sa') }
  }

  // čísla krokov podľa toho, čo sa ukazuje (mockup: poterár 1–4, maliar a omietkár 1 Čo · 2 Na čom · 3 S čím · 4 Kde …)
  const cislo = (() => { let n = 1; const c = { co: n++ }
    c.naCom = naComTreba ? n++ : 0; c.sCim = sCim.length ? n++ : 0
    c.kde = n++; c.prestoj = kontrolny ? 0 : n++; c.foto = n++; return c })()
  // „Chýba: …“ — to isté, čo stráži server (dennik_katalog.zlozZapis)
  const chyba = []
  if (!pid) chyba.push(T.ch_zakazka)
  else {
    if (kontrolny) { if (!f.kontrola.length && !String(f.poznamka || '').trim()) chyba.push(T.ch_zistenia) }
    else if (!f.prace.length && !(prestoj && Number(f.hodiny) >= 8)) chyba.push(T.ch_prace)
    if (miestaZak.length && !f.miesta.length) chyba.push(T.ch_miesto)
    if (!kontrolny && prestoj) {
      if (!(Number(f.hodiny) > 0)) chyba.push(T.ch_hodiny)
      if (!f.zavinil) chyba.push(T.ch_zavinil)
      if (chybaPrestoj) chyba.push(prestoj.fotka_text || T.foto_prestoj)
    }
    if (chybaPredstav) chyba.push(T.foto_predstav)
  }
  const chybaText = chyba.length ? vypln(T.chyba || 'Chýba: {co}', { co: chyba.filter(Boolean).join(', ') }) : ''

  // zhrnutie „Toto pôjde do denníka“ (v jazyku človeka)
  const miestaTxt = f.miesta.length ? f.miesta.map(miestoText).join(', ') : (kat?.miesta?.celok_text || '')
  const coTxt = (kontrolny ? f.kontrola : f.prace).map(k => mk[k]?.text).filter(Boolean).join(', ')
  const naComTxt = naComTreba ? (kat?.na_com || []).filter(x => (f.na_com || []).includes(x.kluc)).map(x => String(x.text).toLowerCase()).join(', ') : ''
  const matTxt = sCim.map(x => (x.mats.find(m => m.kluc === (f.materialy || {})[x.sada]) || {}).text).filter(Boolean).join(', ')
  const nFot = nove.length + stare.length
  const ktoVeta = (k) => { const z = (kat?.zavinil || []).find(x => x.kluc === k); return z ? (z.veta || z.text) : '' }
  const hTxt = Number(f.hodiny) ? hodText(kat, f.hodiny) : '?'
  const dovodTxt = prestoj ? (prestoj.veta || String(prestoj.text || '').toLowerCase()) : ''
  const zavinilPozn = prestoj && prestoj.pri
    ? vypln(prestoj.kto_zavinil === 'objednavatel' ? T.zavinil_pozn_obj : T.zavinil_pozn_iny, { pri: prestoj.pri, kto: ((kat?.zavinil || []).find(x => x.kluc === prestoj.kto_zavinil) || {}).text || '' })
    : T.zavinil_pozn
  suhrnRef.current = [coTxt, miestaTxt].filter(Boolean).join(' — ')

  async function ulozit() {
    if (chyba.length) return
    const ok = await ed.submit()
    if (ok) {
      const v = vysledok.current || {}
      if (v.offline) toast.success(T.offline_ok || 'Uložené v telefóne')
      setHotovo({ offline: !!v.offline })
    }
  }
  function dalsi() {   // len pri novom zápise — doplnený zápis sa „Ďalším zápisom“ neprepíše
    nove.forEach(x => { try { URL.revokeObjectURL(x.url) } catch (_) {} })
    setNove([]); savedUid.current = null; setHotovo(null); vznik.current = { date: '', time: casTeraz() }
    ed.setValues({ ...initial, entry_type: f.entry_type, prace: [], kontrola: [], miesta: [], na_com: [], materialy: {}, prestoj: '', hodiny: 0, zavinil: '', poznamka: '', fotky_n: 0 })
    setKatZnovu(n => n + 1)   // prvý zápis, posledný materiál a dnešné zápisy sa načítajú znova
  }

  const navBar = (
    <div style={{ position: 'sticky', top: 0, zIndex: 5, background: COLORS.page, display: 'flex', alignItems: 'center', gap: 6, padding: '4px 0 6px' }}>
      <button type="button" onClick={() => hotovo ? onSaved() : (lenCitanie ? onClose() : ed.requestClose(onClose))}
        style={{ background: 'transparent', border: 'none', color: COLORS.nav, fontWeight: 600, fontSize: 16, minHeight: 44, minWidth: 60, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', padding: 0 }}>
        ‹ {T.spat || 'Späť'}
      </button>
      <span style={{ flex: 1, textAlign: 'center', fontWeight: 700, fontSize: 16, marginRight: 60 }}>
        {kontrolny ? (T.nadpis_kontrola || '') : (T.nadpis || '')}{ed.isDirty && !hotovo && !lenCitanie ? ' *' : ''}
      </span>
    </div>
  )

  if (!kat) return <div style={M.page}>{navBar}<div style={{ ...M.card, textAlign: 'center', color: COLORS.muted }}>…</div></div>

  // ── uložené — potvrdenie (60.3 odmeňuje, nenúti) ──
  if (hotovo) {
    return (
      <div style={M.page}>
        {navBar}
        <div style={{ ...M.card, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, padding: 20 }}>
          <span style={{ width: 56, height: 56, borderRadius: 999, background: COLORS.add, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><NavIcon name="check" size={30} /></span>
          <div style={{ fontSize: 20, fontWeight: 800 }}>{T.ulozene}</div>
          {hotovo.offline && <div style={{ color: '#92400e', fontWeight: 600, textAlign: 'center' }}>{T.offline_ok}</div>}
          <div style={{ color: COLORS.muted, fontSize: 13 }}>{T.upravit_dnes}</div>
          <button type="button" style={{ ...M.btnPrimary, background: COLORS.add, marginTop: 6 }} onClick={onSaved}>{T.hotovo}</button>
          {novy && <button type="button" style={{ ...M.btnGhost, width: '100%' }} onClick={dalsi}>{T.dalsi_zapis}</button>}
        </div>
      </div>
    )
  }

  // ── len na čítanie: starý tvar, cudzí zápis (doplní len admin), zápis medzitým upravený v Matrixe ──
  if (lenCitanie) {
    return (
      <div style={M.page}>
        {navBar}
        <Karta nadpis={record.date + ' · ' + (record.project_name || record.project_id)}>
          <div style={{ whiteSpace: 'pre-wrap', fontSize: TYPO.sizes.md }}>{popisZapisu(record, kat, lang) || '—'}</div>
          {Number(record.stoppage_hours) > 0 && <div style={{ marginTop: 8, color: '#92400e', fontWeight: 600 }}>{record.stoppage_hours} h · {record.stoppage_reason} {record.stoppage_note ? '(' + record.stoppage_note + ')' : ''}</div>}
          <p style={M.pozn}>{record.is_locked ? T.zamknute : (staryTvar ? T.stary_tvar : (cudzi ? T.len_autor : T.upravene_inde))}</p>
        </Karta>
        {stare.length > 0 && <Karta><div style={M.chips}>{stare.map(p => <img key={p.id} alt="" src={'/uploads/diary/' + record.project_id + '/' + (p.thumb_filename || p.filename)} style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 10 }} />)}</div></Karta>}
      </div>
    )
  }

  const zakazkyDna = kat.zakazky_dna || []
  const zbalTlacidlo = { marginTop: 6, width: '100%', textAlign: 'center', color: COLORS.muted, fontWeight: 600, fontSize: 12.5, padding: '6px 4px', border: 'none', background: 'transparent', cursor: 'pointer', fontFamily: 'inherit' }
  const ineTlacidlo = { marginTop: 8, width: '100%', textAlign: 'center', color: COLORS.nav, fontWeight: 700, fontSize: 13.5, padding: 9, border: '1.5px dashed #93C5FD', borderRadius: 12, background: 'transparent', cursor: 'pointer', fontFamily: 'inherit' }
  const ineVybrane = f.prace.some(k => (kat.ine_remesla || []).some(s => s.polozky.some(p => p.kluc === k)))
  return (
    <div style={M.page}>
      {navBar}
      {kat.zakazka && <p style={{ color: COLORS.muted, fontSize: 13, margin: '0 0 2px' }}>{kat.zakazka.nazov} · {denVTyzdni(T, record?.date || kat.datum)}</p>}

      {zamknute && <div style={{ ...M.card, border: `2px solid ${COLORS.muted}`, color: COLORS.muted, fontWeight: 600 }}>{T.zamknute}</div>}
      {ed.lockedBy && <div style={{ ...M.card, border: `2px solid ${AMBER}`, color: AMBER, fontWeight: 700 }}>{ed.lockedBy}</div>}

      {/* zákazka: parťák zo zákaziek dňa (Rozpis, Príchod), technik / majiteľ / admin hocijakú */}
      {novy && (!kat.zakazka || zakazkyDna.length > 1 || control) && (
        <Karta nadpis={T.zakazka_vyber}>
          {zakazkyDna.length > 0 && <div style={M.chips}>{zakazkyDna.map(z => <button key={z.id} type="button" style={chip(pid === z.id)} onClick={() => { setPid(z.id); set('miesta', []) }}>{z.nazov}</button>)}</div>}
          {control && projekty.length > 0 && (
            <select style={{ ...M.input, marginTop: zakazkyDna.length ? 8 : 0 }} value={pid} onChange={e => { setPid(e.target.value); set('miesta', []) }}>
              <option value="">— {T.zakazka_vyber} —</option>
              {projekty.map(p => <option key={p.id} value={p.id}>{p.name} ({p.id})</option>)}
            </select>
          )}
          {!zakazkyDna.length && !control && <p style={M.pozn}>{T.ziadna_zakazka}</p>}
        </Karta>
      )}

      {kat.zakazka && (
        <fieldset disabled={zamknute || !!ed.lockedBy} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          {!kontrolny && kat.kto?.veta && <div style={{ background: '#E0F2FE', color: '#075985', borderRadius: 10, padding: '8px 10px', fontSize: 12.5, lineHeight: 1.35 }}><VetaKto veta={kat.kto.veta} osoba={kat.kto.osoba} /></div>}

          {/* technik, majiteľ, admin — typ zápisu (Denný predvolený, Mirko 29. 9.) */}
          {typy.length > 1 && (
            <Karta nadpis={T.typ_zapisu}>
              <div style={M.chips}>{typy.map(ty => <button key={ty} type="button" style={chip(f.entry_type === ty)} onClick={() => set('entry_type', ty)}>{T['t_' + ty]}</button>)}</div>
            </Karta>
          )}

          {/* 1 — čo si dnes robil / čo si zistil */}
          {kontrolny ? (
            <Karta krok="1" nadpis={T.krok_zistenia}>
              {(kat.kontrola || []).map(s => (
                <div key={s.sada}>
                  <div style={M.sk}>{s.nazov}</div>
                  <div style={M.grid}>{s.polozky.map(p => <Dlazdica key={p.kluc} on={f.kontrola.includes(p.kluc)} text={p.text} onClick={() => prepni('kontrola', p.kluc)} />)}</div>
                </div>
              ))}
            </Karta>
          ) : (
            <Karta krok="1" nadpis={T.krok_co}>
              {(kat.sady || []).map(s => (s.zbalena && !vsetciOpen && !s.polozky.some(p => f.prace.includes(p.kluc))) ? (
                <button key={s.sada} type="button" onClick={() => setVsetciOpen(true)} style={zbalTlacidlo}>{kat.vsetci_zbalene_text || s.nazov}</button>
              ) : (
                <div key={s.sada}>
                  <div style={M.sk}>{s.nazov}</div>
                  <div style={M.grid}>{s.polozky.map(p => <Dlazdica key={p.kluc} on={f.prace.includes(p.kluc)} ikona={p.ikona} text={p.text} mini={p.popis} onClick={() => prepni('prace', p.kluc)} />)}</div>
                </div>
              ))}
              {(kat.ine_remesla || []).length > 0 && (ineOpen || ineVybrane) ? (
                <>
                  {(kat.ine_remesla || []).map(s => (
                    <div key={s.sada}>
                      <div style={M.sk}>{s.nazov}</div>
                      <div style={M.grid}>{s.polozky.map(p => <Dlazdica key={p.kluc} on={f.prace.includes(p.kluc)} ikona={p.ikona} text={p.text} mini={p.popis} onClick={() => prepni('prace', p.kluc)} />)}</div>
                    </div>
                  ))}
                  {!ineVybrane && <button type="button" onClick={() => setIneOpen(false)} style={ineTlacidlo}>{T.skryt_ine}</button>}
                </>
              ) : (kat.ine_remesla || []).length > 0 && (
                <button type="button" onClick={() => setIneOpen(true)} style={ineTlacidlo}>
                  {kat.ine_remesla_text || vypln(T.ine_remeslo, { zoznam: [...new Set((kat.ine_remesla || []).map(s => s.remeslo || s.nazov))].join(', ') })}
                </button>
              )}
            </Karta>
          )}

          {/* mockup v2 — Na čom (strop, steny, špalety) */}
          {naComTreba && (
            <Karta krok={String(cislo.naCom)} nadpis={T.krok_na_com}>
              <div style={M.chips}>{(kat.na_com || []).map(x => <button key={x.kluc} type="button" style={chip((f.na_com || []).includes(x.kluc))} onClick={() => prepni('na_com', x.kluc)}>{x.text}</button>)}</div>
              {maliarVybrany && <p style={M.pozn}>{T.na_com_pozn}</p>}
            </Karta>
          )}
          {/* mockup v2 — S čím (materiál zo sady, predvolený naposledy použitý) */}
          {sCim.map(x => (
            <Karta key={'m_' + x.sada} krok={String(cislo.sCim)} nadpis={T.krok_s_cim + (x.pre.length ? ' (' + x.pre.map(k => String(mk[k]?.text || '').toLowerCase()).join(', ') + ')' : '') + (sCim.length > 1 ? ' · ' + ((vsetkySady(kat).find(s => s.sada === x.sada) || {}).nazov || '') : '')}>
              <div style={M.chips}>{x.mats.map(m => <button key={m.kluc} type="button" style={chip((f.materialy || {})[x.sada] === m.kluc)} onClick={() => set('materialy', { ...(f.materialy || {}), [x.sada]: (f.materialy || {})[x.sada] === m.kluc ? '' : m.kluc })}>{m.text}</button>)}</div>
              <p style={M.pozn}>{T.material_pozn}</p>
            </Karta>
          ))}

          {/* kde */}
          <Karta krok={String(cislo.kde)} nadpis={T.krok_kde}>
            {miestaZak.length === 0 ? (
              <div style={M.chips}><span style={chip(true)}>{kat.miesta?.celok_text}</span></div>
            ) : objekty.map(o => (
              <div key={o || '_'}>
                {objekty.length > 1 && <div style={{ ...M.sk, color: COLORS.muted }}>{o}</div>}
                <div style={M.chips}>{miestaZak.filter(m => m.obj === o).map(m => <button key={m.kluc} type="button" style={chip(vybraneMiesto(m))} onClick={() => prepniMiesto(m)}>{m.text}</button>)}</div>
              </div>
            ))}
            {jednoMiesto && jednoMiesto.byty.length > 0 && (
              <>
                <div style={M.sk}>{T.byt}</div>
                <div style={M.chips}>{jednoMiesto.byty.map(b => (
                  <button key={b} type="button" style={chip(f.miesta[0].byt === b)} onClick={() => set('miesta', [{ ...f.miesta[0], byt: f.miesta[0].byt === b ? '' : b }])}>{b}</button>
                ))}</div>
              </>
            )}
            <p style={M.pozn}>{T.miesta_pozn}</p>
          </Karta>

          {/* prestoj (denný zápis) */}
          {!kontrolny && (
            <Karta krok={String(cislo.prestoj)} nadpis={T.krok_prestoj}>
              <div style={M.grid}>
                <Dlazdica on={!f.prestoj} ikona="ok" text={T.nestal} onClick={() => vyberPrestoj(null)} />
                {(kat.prestoje || []).map(p => (
                  <Dlazdica key={p.kluc} amber on={f.prestoj === p.kluc} ikona={p.ikona} text={p.text}
                    mini={[p.popis, p.fotka_povinna ? T.foto_mini : ''].filter(Boolean).join(' · ')} onClick={() => vyberPrestoj(p)} />
                ))}
              </div>
              {prestoj && (
                <>
                  <div style={M.sk}>{T.kolko}</div>
                  <div style={M.chips}>{(kat.hodiny || []).map(x => <button key={x.h} type="button" style={chip(Number(f.hodiny) === Number(x.h), true)} onClick={() => set('hodiny', x.h)}>{x.text}</button>)}</div>
                  <div style={M.sk}>{T.kto_zavinil}</div>
                  <div style={M.chips}>{(kat.zavinil || []).map(z => <button key={z.kluc} type="button" style={chip(f.zavinil === z.kluc, true)} onClick={() => set('zavinil', z.kluc)}>{z.text}</button>)}</div>
                  <p style={M.pozn}>{zavinilPozn}</p>
                </>
              )}
            </Karta>
          )}

          {/* technik — opatrenie a prevzatie (ústava 25.2) */}
          {kontrolny && (
            <Karta nadpis={T.opatrenie}>
              <input style={{ ...M.input, marginBottom: 6 }} placeholder={T.opatr_co} value={f.opatr_co} onChange={e => set('opatr_co', e.target.value)} />
              <div style={{ display: 'flex', gap: 6 }}>
                <input type="date" style={{ ...M.input, flex: 1 }} aria-label={T.opatr_do} value={f.opatr_do} onChange={e => set('opatr_do', e.target.value)} />
                <input style={{ ...M.input, flex: 1 }} placeholder={T.opatr_kto} value={f.opatr_kto} onChange={e => set('opatr_kto', e.target.value)} />
              </div>
            </Karta>
          )}
          {kontrolny && (
            <Karta nadpis={T.prevzatie}>
              <input style={{ ...M.input, marginBottom: 6 }} placeholder={T.prevzate} value={f.prevzatie} onChange={e => set('prevzatie', e.target.value)} />
              <input style={M.input} placeholder={T.odovzdane} value={f.odovzdanie} onChange={e => set('odovzdanie', e.target.value)} />
            </Karta>
          )}

          {/* fotka */}
          <Karta krok={String(cislo.foto)} nadpis={(nadpisFotky.charAt(0).toUpperCase() + nadpisFotky.slice(1)) + ' ' + ((potrebaPrestoj || potrebaPredstav) ? (T.povinna || '') : (T.nepovinna || ''))}>
            {potrebaPredstav && <p style={{ ...M.pozn, margin: '0 0 8px' }}>{T.predstav_hint}</p>}
            {[...stare.map(p => ({ stara: p, url: '/uploads/diary/' + pid + '/' + (p.thumb_filename || p.filename) })),
              ...nove.map((x, i) => ({ ...x, i }))].map((x, j) => (
              <div key={j} style={{ height: 92, borderRadius: 12, marginBottom: 6, backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0) 45%, rgba(0,0,0,.6)), url(${x.url})`, backgroundSize: 'cover', backgroundPosition: 'center',
                display: 'flex', alignItems: 'flex-end', padding: 8, color: '#fff', fontSize: 12, fontWeight: 700, gap: 6 }}>
                <span style={{ display: 'flex' }}><NavIcon name="fotak" size={18} /></span>
                <span style={{ flex: 1 }}>{miestaTxt}{x.kedy ? ' · ' + x.kedy.getDate() + '. ' + (x.kedy.getMonth() + 1) + '. ' + String(x.kedy.getHours()).padStart(2, '0') + ':' + String(x.kedy.getMinutes()).padStart(2, '0') : ''}</span>
                <button type="button" onClick={() => x.stara ? odoberStaru(x.stara) : prefotit(x.i)} style={{ background: 'rgba(255,255,255,.9)', color: COLORS.text, border: 'none', borderRadius: 8, padding: '4px 8px', fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' }}>
                  {x.stara ? T.odobrat : T.prefotit}
                </button>
              </div>
            ))}
            <button type="button" onClick={() => otvorFoto(dalsiePole())} style={{ ...dl(false, false, true), minHeight: 56, flexDirection: 'row', gap: 8 }}>
              <span style={{ display: 'flex', color: COLORS.nav }}><NavIcon name="fotak" size={20} /></span> {(nove.length + stare.length) ? T.dalsia_foto : T.odfotit}
            </button>
            <input ref={fotoRef} type="file" accept="image/*" capture="environment" multiple style={{ display: 'none' }} onChange={pridajFotky} />
          </Karta>

          {/* zhrnutie — „Toto pôjde do denníka“ */}
          <Karta nadpis={T.zhrnutie}>
            <div style={{ background: '#FFFBEB', border: '1px solid #FCD34D', borderRadius: 12, padding: 10, fontSize: 13.5, lineHeight: 1.45 }}>
              <b>{coTxt || '—'}</b>{naComTxt ? ' · ' + naComTxt : ''}{miestaTxt ? ' · ' + miestaTxt : ''}<br />
              {matTxt ? <>{vypln(T.zhr_material, { m: matTxt })}<br /></> : null}
              {(!kontrolny && prestoj)
                ? <><VetaPrestoja sablona={T.zhr_prestoj || ''} h={hTxt} dovod={dovodTxt} kto={ktoVeta(f.zavinil) || '?'} />{nFot ? ' · ' + pocetFotiekText(T, nFot) : ''}<br /></>
                : <>{kontrolny ? '' : (T.zhr_bez || '')}{nFot ? (kontrolny ? '' : ' · ') + pocetFotiekText(T, nFot) : ''}{(!kontrolny || nFot) ? <br /> : null}</>}
              {[vypln(T.zhr_ludia, { n: Math.max(0, (Number(kat.dnes?.ludia) || 1) - 1) }), teplota != null ? teplota + ' °C' : '', kat.dnes?.prichod ? vypln(T.zhr_prichod, { cas: kat.dnes.prichod }) : ''].filter(Boolean).join(' · ')}
            </div>
          </Karta>

          {/* poznámka — nepovinná, diktovaním */}
          <Karta nadpis={(T.poznamka || '') + ' ' + (T.nepovinna || '')}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, background: COLORS.bgSoft, border: `1.5px solid ${COLORS.line}`, borderRadius: 12, padding: '10px 12px' }}>
              <span style={{ color: COLORS.nav, display: 'flex', paddingTop: 1 }}><NavIcon name="mikrofon" size={20} /></span>
              <textarea value={f.poznamka} onChange={e => set('poznamka', e.target.value)} placeholder={T.poznamka_ph} rows={2}
                style={{ flex: 1, border: 'none', background: 'transparent', fontFamily: 'inherit', fontSize: 14, resize: 'vertical', outline: 'none', minHeight: 40 }} />
            </div>
            <p style={M.pozn}>{T.poznamka_pozn}</p>
          </Karta>

          {ed.error && <div style={{ color: COLORS.remove, fontWeight: 700, textAlign: 'center', fontSize: 13.5 }}>{ed.error}</div>}
          <button type="button" disabled={!!chyba.length || ed.submitting} onClick={ulozit} style={{
            background: chyba.length ? '#CBD5E1' : COLORS.add, color: chyba.length ? '#475569' : '#fff', textAlign: 'center', fontWeight: 800, fontSize: 17,
            borderRadius: 16, padding: 15, border: 'none', letterSpacing: '.02em', cursor: chyba.length ? 'default' : 'pointer', fontFamily: 'inherit', minHeight: 54 }}>
            {ed.submitting ? T.ukladam : T.ulozit}
          </button>
          {chybaText && <div style={{ color: '#DC2626', fontWeight: 700, textAlign: 'center', fontSize: 13.5 }}>{chybaText}</div>}
          <p style={{ ...M.pozn, textAlign: 'center' }}>{T.upravit_dnes}</p>

          {/* poterový protokol pri každej zákazke (Mirko 13. 9. 2026); typ zákazky dlaždice nemení (mockup v2) — pri poterovej zákazke je tlačidlo výrazné */}
          {!kontrolny && (
            <button type="button" onClick={() => setProtokolOpen(o => !o)} style={{ ...M.btnGhost, width: '100%', ...(kat.zakazka.poter ? { color: COLORS.nav, borderColor: COLORS.nav, borderWidth: 2 } : { color: COLORS.muted, borderColor: COLORS.line }) }}>
              {protokolOpen ? T.protokol_skryt : T.protokol}
            </button>
          )}
          {!kontrolny && protokolOpen && <PoterProtokolView embedded fixedProject={{ id: kat.zakazka.id, name: kat.zakazka.nazov, type: kat.zakazka.typ, segment: kat.zakazka.segment }} onSaved={onSaved} />}
        </fieldset>
      )}

      {/* DIRTY dialóg — neuložené zmeny pri odchode (ústava 53.1) */}
      <Modal.DirtyConfirm {...ed.dirtyProps} />
    </div>
  )
}
